import loadable from '@loadable/component'
import Coupon from './Coupon'
import Orders from './Orders'

export default {
    '/:type/my/levelinfo': loadable(() => import('./LevelInfo')),
    '/:type/my/note': loadable(() => import('./Note')),
    '/:type/my/note/noteDetail': loadable(() => import('./Note/noteDetail')),
    '/:type/my/topic': loadable(() => import('./myQuestions')),
    '/:type/my/comment': loadable(() => import('./myAnswers')),
    '/fakao/my/history': loadable(() => import('./History')),
    '/fashuo/my/history': loadable(() => import('./History')),
    '/:type/my/courses': loadable(() => import('./courses')),
    '/:type/my/orderBind': loadable(() => import('./orderBind')),
    '/:type/my/studyPlanReport': loadable(() => import('./StudyPlanReport')),
    '/:type/my/schedule': loadable(() => import('./schedule')),  // 报错先注释调
    '/:type/my/studyPlan': loadable(() => import('./StudyPlan')),
    '/:type/my/notice': loadable(() => import('./Notice')),
    ...Coupon,
    ...Orders
}
